export class BoletoEntity {
  status = null;
	dataVencimento = null;
	valorTotal = null;
  nfSaidaId = null;
	contaReceberId = null;
	clienteId = null;
	meioPagamentoId = null;
  convenioId = null;
  integradorId = null;
  integradorImpressaoId = null;
  tituloDocumento = null;
  tituloNossoNumero = null;
	observacoes = null;

	constructor(boletoApi, contaReceber, convenio, clienteId, erros) {
		if (!convenio?.registroInstantaneo) {
			this.status = "EMITIDO";
		} else {
			this.status = boletoApi?.situacao;
		}
		this.dataVencimento = new Date(contaReceber?.dataVencimento);
		this.valorTotal = contaReceber?.valor;
		this.nfSaidaId = contaReceber?.nfSaidaId;
		this.contaReceberId = contaReceber?.id;
		this.clienteId = clienteId;
		this.meioPagamentoId = contaReceber?.meioPagamentoId;
		this.convenioId = convenio?.id;
		this.integradorId = boletoApi?.idintegracao;
		this.integradorImpressaoId = boletoApi?.idImpressao;
		this.tituloDocumento = contaReceber.numeroTitulo;
		this.tituloNossoNumero = boletoApi?.TituloNossoNumero;
		this.observacoes = erros;
	}
}